<template>
    <div>
        <hr>
        <div class="row-sezione">
            <div class="row mb-3"
                 v-if="this.fAsap">
                <div class="col-12">
                    <mcw-checkbox @change="this.onAsapChange" :checked="this.currAsap">
                        <img class="m-0 p-0 px-2" height="22" src="/img/be/ico-asap.png"/>
                        {{$t("ordine_appena_possibile")}}
                    </mcw-checkbox>
                </div>
            </div>
            <div class="text-center">
              <button type="button" class="btn btn-menu" @click="$emit('onSeeMenuTap')">
                  {{this.specificTranslation("vedi_menu")}}
              </button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "LvFinal",
    props: ['currType', 'fAsap', 'currAsap'],
    methods: {
        onAsapChange: function () {
            this.$emit('onAsapChange', !this.currAsap);
        }
    },
    computed: {
        ...mapGetters('restaurant', [
            'specificTranslation'
        ]),
    }
}
</script>
